import React, { useState } from 'react';
// import { Mail } from 'lucide-react';
import './ContactForm.css';
import { toast } from 'react-toastify';
import { DataService } from '../DataService/DataService';
import { ContactRequest } from '../Types/EmailContactRequest';
import Loader from './Loader';
import { Turnstile } from '@marsidev/react-turnstile';

const ContactForm = () => {
  const [submitting,setSubmitting] = React.useState<boolean>(false);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    consent: false
  });

  const handleSubmit = async(e: React.FormEvent):Promise<void> => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    if(!formData.consent){
      toast.error('Du måste godkänna att det är okej att vi kontaktar dig');
    } else if (!captchaToken) {
      toast.error('Bekräfta att du inte är en robot');
      
    }else{
      setSubmitting(true)
      try {
        const request:ContactRequest = {
          fullName: formData.name,
          email: formData.email,
          message: formData.message,
          captchaToken,
          templateType: 1,
          userAgent: window.navigator.userAgent,
        };
        await DataService.EmailList.SendContactRequest(request);
        toast.success('Tack för ditt meddelande! Vi återkommer till dig snart.');
        setFormData({name:'',email:'',message:'',consent:false});
        setCaptchaToken(null);
      } catch (err) {
        toast.error('Kunde inte skicka meddelandet.');
      } finally {
        setSubmitting(false);
      }
    }
    
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  return (
    <section id="kontakt" className="contact-section">
      <div className="contact-container">
        <div className="contact-grid">
          <div className="contact-info">
            <h2>Skriv till Sandra</h2>
            <p>
              Har du en fråga, vill bolla något eller känna efter om något passar dig?
              Skriv gärna ett meddelande så återkommer vi inom 48 timmar.
            </p>
            <div className="contact-email">
              {/* <Mail className="mail-icon" /> */}
              <span>info@sandrashälsa.se</span>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <form onSubmit={handleSubmit} className="contact-form">
              <div>
                <label htmlFor="name">Namn *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Ditt namn"
                />
              </div>

              <div>
                <label htmlFor="email">E-post *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="din@email.se"
                />
              </div>

              <div>
                <label htmlFor="message">Meddelande *</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Berätta hur vi kan hjälpa dig..."
                />
              </div>

              <div className="contact-turnstile-block">
                <label>Jag är inte en robot *</label>
                <Turnstile
                  siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY!}
                  onSuccess={(token) => setCaptchaToken(token)}
                  onExpire={() => setCaptchaToken(null)}
                  options={{ theme: 'light' }}
                />
              </div>

              <div >
                <input
                  type="checkbox"
                  id="consent"
                  name="consent"
                  required
                  checked={formData.consent}
                  onChange={handleChange}
                />
                <label htmlFor="consent">
                  Jag godkänner att ni kontaktar mig och behandlar mina personuppgifter enligt er
                  <a href="/privacy-policy"> integritetspolicy</a>.
                </label>
              </div>

              <button type="submit" className="submit-button" disabled={submitting || !captchaToken}>
                 {submitting ? <div style={{position:'relative',display:'flex',justifyContent:'center'}}><Loader loaderSize={'SMALL'}/></div>:
                <>Skicka meddelande</>
                }
              </button>
            </form>
          </div>
        </div>

        {/* <div className="referral-banner">
          <h3>Tipsa en vän – få 100 kr rabatt!</h3>
          <p>
            När din vän köper en kurs får ni båda 100 kr rabatt på nästa köp
          </p>
          <button className="referral-button">
            Läs mer om vårt hänvisningsprogram
          </button>
        </div> */}
      </div>
    </section>
  );
};

export default ContactForm;
